var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-modal-loading"},[_c('div',{staticClass:"cart-modal-loading__heading"},[_vm._v("讀取購物車中...")]),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("繼續購物")])])}
var staticRenderFns = []

export { render, staticRenderFns }